export interface MultiLangField {
  pl: string;
  en: string;
  uk: string;
  ru: string;
}
